import template from './overlay.dot';
const overlayTemplate = template.default ? template.default : template;
export { overlayTemplate };
